import { Lesson } from "./types";

export type DicussTopic = {
  text?: string;
  storyImageUrl?: string;
};
export default function getDiscussTopics(lesson: Lesson): DicussTopic[] {
  if (!lesson || !lesson.sections) {
    return [];
  }

  const discuss = lesson.sections.find((section) => /discuss/i.test(section.title));

  if (!discuss) {
    return [];
  }

  // It looks like we've saved html on the backend so that we can render this elsewhere
  // we only want to get the title that's between <h1>TITLE</h1>
  // and we escape the state where we've loaded this to make things safe from XSS
  // a better solution would be to track down where this is initially being set
  // and do the parsing then
  // (or to actually fix it so that we're not relying as our source of truth...)
  const TEXT_REGEX = /(?:\&lt;h1\&gt;|<h1>)(.+)(?:\&lt;\/h1\&gt;|<\/h1>)/;

  return discuss.slides
    .filter((slide) => {
      return slide.type === "html" && slide.content && TEXT_REGEX.test(slide.content);
    })
    .map((slide) => {
      return {
        text: slide.content?.match(TEXT_REGEX)?.[1],
        storyImageUrl: slide.storyImageUrl,
      };
    });
}
